import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { markFreeTextResponse } from "../../../api/commands.js";
import { getTestAttempt } from "../../../api/queries.js";
import { useQuery } from "../../../api/useQuery.js";
import { ProcessingStatus } from "../../../components/molecules/ProcessingStatus.js";
import { QueryStatus } from "../../../components/ui/LoadingPlaceholders.js";
import { ErrorState, useT } from "@mmm/ui";
export function FreeTextMarkingScreen() {
  const { subjectId = "", testId = "", attemptId = "" } = useParams();
  const t = useT();
  const query = useQuery(getTestAttempt, { attemptId });
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  const questions = query.data?.questions.filter((q) => q.type === "freeText" && q.response?.answeredAt) ?? [];
  const pending = questions.filter((q) => q.response?.pointsAwarded === null);
  const responseId = pending[0]?.response?.id;
  const attemptStatus = query.data?.attempt.status;
  const refresh = query.retry;
  useEffect(() => {
    if (!responseId || attemptStatus !== "submitted") return;
    let active = true;
    const timer = setTimeout(() => {
      setFailed(false);
      markFreeTextResponse({ responseId }).then(() => {
        if (active) refresh();
      }).catch(() => { if (active) setFailed(true); });
    }, 0);
    return () => { active = false; clearTimeout(timer); };
  }, [responseId, attemptStatus, retry, refresh]);
  const basePath = `/subjects/${subjectId}/tests/${testId}/attempts/${attemptId}`;
  if (query.data?.attempt.status === "marked") return <Navigate to={`${basePath}/review`} replace />;
  if (query.data?.attempt.status === "inProgress") return <Navigate to={basePath} replace />;
  if (failed) return <ErrorState title={t("tests.markingFailed")} onRetry={() => setRetry((value) => value + 1)} />;
  if (query.error && !query.waiting) return <ErrorState title={t("tests.loadAttemptFailed")} onRetry={refresh} />;
  if (!query.data) return <QueryStatus queries={[query]} />;
  return <ProcessingStatus title={t("tests.markingAnswers")} message={t("tests.markingProgress", { completed: questions.length - pending.length, total: questions.length })} completed={questions.length - pending.length} total={questions.length} />;
}
